import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, Output, ViewChild, inject, signal } from '@angular/core';

import { MatTableDataSource } from '@angular/material/table';
import { SimilarStructure, Structure} from '../../entry/structure-data.models';
import { MatPaginator } from '@angular/material/paginator';
import { ConfigService } from '../../config.service';
import { GoogleAnalyticsService } from '../../google-analytics.service';
import { MatSort, Sort } from '@angular/material/sort';

import { CheckboxService } from '.././checkbox.service';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { DownloadService } from '../../download-service';
import { FoldseekService } from '../foldseek.service';
import { FoldseekapiService } from '../foldseekapi.service';

@Component({
  selector: 'app-afdb-tab',
  templateUrl: './afdb-tab.component.html',
  styleUrl: './afdb-tab.component.css',
  standalone: false
})
export class AfdbTabComponent {
  @Input() accession: string;
  @Input() afdb_accession: string;

  @Output() toggleClickedEvent: EventEmitter<Object> = new EventEmitter();

  public foldseekService = inject(FoldseekService);
  public foldseekapiService = inject(FoldseekapiService);

  checked = false;
  disabled = false;
  superposeData = [];

  displayedColumnsAFDBStructure: string[] = [
    'expand', 
    'select', 
    'afdbAccessions', 
    'speciesNames', 
    'sequenceLength', 
    'evalue', 
    'sequenceIdentity', 
    'averagePlddt', 
    'alighin3D'
  ];

  afdbStructureDataSource = new MatTableDataSource<SimilarStructure>();

  subTimeout:any;
  isColorby: boolean= true;
  apiData = {};
  targetColors = {};
  checkboxState: { [key: string]: boolean } = {};
  disabledState: { [key: string]: boolean } = {};
  private subscription: Subscription;

  structure: Structure;
  pdbeMolstar: any;
  molLoadComplete:boolean = false;
  viewerInstance: any = undefined;

  filteritemAFDB = this.foldseekapiService.filteritemAFDB();

  private readonly destroyRef = inject(DestroyRef);
  
  constructor(
    public gaService: GoogleAnalyticsService,
    private configService: ConfigService,
    private changeDetectorRef: ChangeDetectorRef,
    private checkboxService: CheckboxService,
) { }

  dropdownOptionsPDB: { label: string, value: any, isShow: boolean, disabled?: boolean, info?: string }[];
  dropdownOptionsAFDB: { label: string, value: any, isShow: boolean, disabled?: boolean, info?: string }[];

  isDownloadFailed = false;
  isDownloadDone = false;
  isDownloadRunning = false;
  readonly MAX_SELECTION = 100;

  isDisabled = false;

  downloadService = inject(DownloadService);
  selectedValuesAFDB = this.downloadService.selectedValuesAFDB;
  allSelectedAFDB = this.downloadService.allSelectedAFDB;
  selectionAFDB = signal<any>(new Set<string>());

  @ViewChild('paginator4',{ static: true }) paginator4!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.downloadService.updateSelectedValueAFDB([]);
    this.subscription = this.checkboxService.checkboxState$.subscribe(state => {
      this.checkboxState = state;
      this.changeDetectorRef.detectChanges(); // Trigger change detection manually
    });

    this.checkboxService.disabledState$.subscribe(state => {
      this.disabledState = state;
    });

    this.dropdownOptionsAFDB = [
      { label: 'Search results (max 10 000)', value: "allresultscsv" , isShow: true, disabled: false},
      { label: 'Coordinates and PAE (max 100)', value: "modelcoordicate", isShow: true, disabled: true},
    ];

    this.foldseekapiService.checkAndGetAFDBData(this.foldseekapiService.recordsAFDB(), this.foldseekapiService.startAFDB(), this.foldseekapiService.sort_direction_AFDB(), this.foldseekapiService.sort_column_AFDB(), this.foldseekapiService.species_name_filter_AFDB());
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  clickToggleSuperpose(event, accession){
    this.toggleClickedEvent.emit({event, accession})
  }
  expandedElementAFDB
  expandRowAFDB(element) {
    this.expandedElementAFDB = this.expandedElementAFDB === element ? null : element
  }

  isRowCheckboxDisabledAFDB(): boolean {
    return this.selectionAFDB().size >= this.MAX_SELECTION;
  }
  
  expandedElementsAFDB = [];
  toggleRowAFDB(element ) {

    const ele = this.expandedElementsAFDB.find(e => e.afdbAccessions === element.afdbAccessions);
    if(ele){
      this.expandedElementsAFDB = this.expandedElementsAFDB.filter(el => el.afdbAccessions !== element.afdbAccessions)
    } else {
      this.expandedElementsAFDB.push(element)
    }
  }
  isExpandedAFDB(element): boolean {
    const ele = this.expandedElementsAFDB.find(e => e.afdbAccessions === element.afdbAccessions);

    return ele ? true : false;
    // return this.expandedElementsAFDB.has(element);
  }
  
}